/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import './style.css'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Input, Table, Radio, Row, Col, Select, Spin, Tooltip } from 'antd'
const Search = Input.Search
const RadioGroup = Radio.Group
const InputGroup = Input.Group
const Option = Select.Option

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 0,
      loading: false,
    }
  }

  onChangeRadio = (e) => {
    this.setState({
      value: e.target.value,
      loading: true,
    })
    let body = {
      id: this.props.club_id,
      wallet_id: e.target.value,
      p: 0,
    }
    this.props.fetchWalletRecord(body).then((res) => {
      this.setState({ loading: false })
    })
  }

  handleCopy = (e) => {}

  render() {
    const { wallet, walletRecord } = this.props
    const recordColumns = [
      {
        title: '流水id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '钱包名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '金额',
        dataIndex: 'init',
        key: 'init',
      },
      {
        title: '增加金额',
        dataIndex: 'income',
        key: 'income',
      },
      {
        title: '支出金额',
        dataIndex: 'outcome',
        key: 'outcome',
      },
      {
        title: '余额',
        dataIndex: 'balance',
        key: 'balance',
      },
      {
        title: '时间',
        dataIndex: 'ctime',
        key: 'ctime',
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <Tooltip placement="top" title="点击复制交易号">
              <CopyToClipboard
                text={record.serial_number}
                onCopy={this.handleCopy}
              >
                <span style={{ color: '#108EE9', cursor: 'default' }}>
                  Copy
                </span>
              </CopyToClipboard>
            </Tooltip>
          )
        },
      },
    ]

    return (
      <div>
        <h3 className="level-rank">钱包</h3>
        <RadioGroup
          onChange={this.onChangeRadio}
          value={this.state.value}
          style={{ width: '100%' }}
        >
          <Row>
            {wallet &&
              wallet.map((item, idx) => {
                return (
                  <Col span={12} key={idx} style={{ marginBottom: '1rem' }}>
                    <Radio value={item.id}>
                      {item.name}&nbsp;&nbsp;余额:
                      <h3 style={{ display: 'inline-block' }}>
                        ￥{item.balance}
                      </h3>
                    </Radio>
                  </Col>
                )
              })}
          </Row>
        </RadioGroup>
        {this.state.value !== 0 && (
          <div>
            {this.state.loading ? (
              <Spin tip="正在加载..." className="level-loading" />
            ) : (
              <div>
                <h3 className="wallet-edit">账单流水</h3>
                <Table
                  rowKey="id"
                  size="small"
                  columns={recordColumns}
                  dataSource={walletRecord.list}
                />
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubList/component/wallet.js